module.exports = __webpack_public_path__ + "static/media/vzx2.12d5b5d6.jpg";